import { CascadiaButtonProps } from "@certn/cascadia/components/button/types";

import { _Button } from "./_Button";

interface Props extends CascadiaButtonProps {
  variant?: "brand-primary" | "success" | "info" | "danger" | "warning";
}

export function PrimaryButton(props: Props) {
  const { variant = "brand-primary", ...buttonProps } = props;

  return (
    <_Button
      color={variant === "brand-primary" ? "text-on-brand" : "text-inverse"}
      fill={`background-${variant}-strong`}
      focusStyle="focus-action"
      hoverFill={`background-${variant}-strong-hover`}
      shadow="shadow-button"
      {...buttonProps}
    />
  );
}
